// extracted by mini-css-extract-plugin
module.exports = {"parent":"MyProfile_parent__1sQEF"};